import type { Directive, DirectiveBinding } from 'vue'

interface ClickOutsideHTMLElement extends HTMLElement {
  handleAnyClick?: (event: MouseEvent) => void
}

const clickOutside: Directive<ClickOutsideHTMLElement, () => void> = {
  beforeMount(el: ClickOutsideHTMLElement, binding: DirectiveBinding<() => void>) {
    el.handleAnyClick = (event: MouseEvent) => {
      if (!(el === event.target || el.contains(event.target as Node))) {
        binding.value()
      }
    }
    window.addEventListener('click', el.handleAnyClick)
  },

  unmounted(el: ClickOutsideHTMLElement) {
    if (el.handleAnyClick) {
      window.removeEventListener('click', el.handleAnyClick)
    }
  },
}

export default clickOutside
